export default "__VITE_ASSET__ZWHEoXcp__";